import React from 'react'
import BonusTemplate from '../../components/templates/quarterlybonus/BonusTemplate'

const QuarterlyBonus = () => {
    return (
        <BonusTemplate />
    )
}

export default QuarterlyBonus